import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getGraphics, getGraphicsById } from "./action";

export const graphicsEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = graphicsEntityAdapter.getInitialState({
  count: 0,
});

export const graphicsSlice = createSlice({
  name: "graphics",
  initialState: initialState,
  reducers: {
    showUploadGraphicModal: (state, action) => {
      state.modals.selectUploadGraphicModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getGraphics.fulfilled, (state, action) => {
      if (action.payload.success) {
        graphicsEntityAdapter.setAll(state, action.payload.imageData);
        state.count = action.payload.totalLength;
      }
    });
    builder.addCase(getGraphicsById.fulfilled, (state, action) => {
      if (action.payload.success) {
        graphicsEntityAdapter.setOne(state, action.payload.data);
      }
    });
  },
});

export const { showUploadBumperModal } = graphicsSlice.actions;

export default graphicsSlice.reducer;
